import React from 'react';
import { MotionConfig } from 'framer-motion';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="35bsfuznndaua">
      <SalesPage data-id="element-1" data-mp="3k9kt1l5q1n5b" />
    </MotionConfig>;
}